function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "invoice",
  d: "M29.853,34.428l-2.3,2.3-2.3-2.3-2.3,2.3-2.3-2.3-2.3,2.3-2.3-2.3-2.3,2.3-2.3-2.3-2.3,2.3-2.3-2.3-2.3,2.3-2.3-2.3-2.3,2.3V2.3A2.206,2.206,0,0,1,.7.681,2.206,2.206,0,0,1,2.31,0H29.853a2.206,2.206,0,0,1,1.614.681A2.206,2.206,0,0,1,32.148,2.3V36.723Zm-24.1-4.59h6.886a1.148,1.148,0,0,0,0-2.3H5.753a1.148,1.148,0,0,0,0,2.3Zm21.8-24.1A1.164,1.164,0,0,0,26.41,4.59H5.753A1.164,1.164,0,0,0,4.605,5.738V19.509a1.164,1.164,0,0,0,1.148,1.148H18.377V24.1a1.164,1.164,0,0,0,1.148,1.148H26.41A1.164,1.164,0,0,0,27.557,24.1ZM20.672,20.657h4.59v2.3h-4.59Zm0-4.59h4.59v2.3h-4.59Zm0-4.59h4.59v2.3h-4.59Zm0-4.59h4.59v2.3h-4.59ZM6.9,16.066H18.377v2.3H6.9Zm0-4.59H18.377v2.3H6.9Zm0-4.59H18.377v2.3H6.9Z",
  transform: "translate(-0.015)",
  fill: "#ac1ede"
});

var SvgInvoice = function SvgInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.133,
    height: 36.723,
    viewBox: "0 0 32.133 36.723",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invoice.1b9fa2c7.svg";
export { ForwardRef as ReactComponent };